import * as React from 'react';
import { createMuiTheme, MuiThemeProvider } from 'material-ui/styles';
import { Redirect, Route, Switch } from 'react-router';
import Login from './modules/Login';
import { history } from './configureStore';
import { Grid } from 'material-ui';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import { ConnectedRouter } from 'react-router-redux';
import { AppState } from './store/reducers';
import { connect } from 'react-redux';
import { isAuthRehydrated } from './store/Auth/auth.reducer';
import InfoSnackbar from './components/InfoSnackbar';
import MediaUpload from './modules/MediaUpload';
import IdolList from './modules/IdolList';
import IdolCreate from './modules/IdolCreate';

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    text: {
      primary: '#FFF',
    },
    primary: {
      main: '#e1f694',
    },
  },
});

const userIsAuthenticated = connectedRouterRedirect({
  redirectPath: '/login',
  allowRedirectBack: false,
  authenticatedSelector: (state: AppState) => {
    return state.auth && state.auth.isLoggedIn;
  },
  wrapperDisplayName: 'UserIsAuthenticated',
});

interface Props {
  isRehydrated?: boolean;
}

class App extends React.PureComponent<Props, {}> {
  private renderLoading() {
    return <div style={{ color: '#fff', fontSize: 26 }} />;
  }

  private renderRouter() {
    return (
      <ConnectedRouter history={history}>
        <div style={{ width: '100%' }}>
          <Switch>
            <Route exact={true} path="/login" component={Login} />
            <Route
              exact={true}
              path="/uploads"
              component={userIsAuthenticated(MediaUpload)}
            />
            <Route
              exact={true}
              path="/idols"
              component={userIsAuthenticated(IdolList)}
            />
            <Route
              exact={true}
              path="/idols/create"
              component={userIsAuthenticated(IdolCreate)}
            />
            <Route
              exact={true}
              path="/idols/create/:idolId"
              component={userIsAuthenticated(IdolCreate)}
            />
            <Redirect to="/uploads" />
          </Switch>
        </div>
      </ConnectedRouter>
    );
  }

  public render() {
    const { isRehydrated } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <div>
          <Grid
            container={true}
            style={{ backgroundColor: '#253238', minHeight: '100vh' }}
            alignItems="flex-start"
            spacing={0}
          >
            {isRehydrated ? this.renderRouter() : this.renderLoading()}
            <InfoSnackbar />
          </Grid>
        </div>
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state: AppState, ownProps: Props) {
  return {
    isRehydrated: isAuthRehydrated(state),
  };
}

export default connect(mapStateToProps)(App as any);



// WEBPACK FOOTER //
// ./src/App.tsx